import { useEffect, useState } from 'react';
import type { Dispatch, SetStateAction } from 'react';

export function getStorageValue<T>(key: string, defaultValue: T) {
  try {
    const saved = localStorage.getItem(key);
    if (saved == null) {
      return defaultValue;
    }
    const initial = JSON.parse(saved);
    return initial ?? defaultValue;
  } catch {
    return defaultValue;
  }
}

export function useLocalStorage<T>(key: string, defaultValue: T) {
  const [value, setValue] = useState<T>(() => {
    return getStorageValue(key, defaultValue);
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // If localStorage is not available, we can ignore the error
    }
  }, [key, value]);

  // oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
  return [value, setValue] as [T, Dispatch<SetStateAction<T>>];
}
